<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <div class="header">
      <van-nav-bar :title="$t('my.sys_notice')" class="nav-bar">
        <template #left>
          <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-empty v-if="!loading && notice.length === 0" :description="$t('withdraw.empty_data')" />
          <div class="listItem" :class="{'is-unread': Number(v.is_read) !== 1}" v-for="v in notice" :key="v.id">
            <div class="listTitle"><span v-if="Number(v.is_read) !== 1" class="unread-dot"></span>{{ v.name }}</div>
            <div class="listContent html"><p>{{ v.text }}<br></p></div>
            <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice:[],
      loading: true,
      finished: false,
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getNoticeList(){
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res=>{
        const raw = res && res.data;
        this.notice = Array.isArray(raw)
          ? raw
          : (raw && typeof raw === 'object' ? Object.values(raw) : []);
        const unreadIds = this.notice.filter(item => Number(item.is_read) !== 1).map(item => item.id);
        if (unreadIds.length > 0 && localStorage.getItem('token')) {
          this.$http({ method: 'post', url: 'sys_mark_notice_read', data: { ids: unreadIds.join(',') } })
            .then(() => { this.notice = this.notice.map(item => ({ ...item, is_read: 1 })); });
        }
      }).catch(() => {
        this.notice = [];
      }).finally(() => {
        this.loading = false;
        this.isLoading = false;
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.replace({path:'/Login'});
    } else {
      this.getNoticeList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .content {
  height: calc(100% - 20px);
  overflow: auto;
}
.container .content .listItem{
  margin-bottom: 20px;
  padding: 20px 20px 0;
  position: relative;
  color: #f3c7a2;
  // background-color: #fff;
}
.container .content .listItem.is-unread{
  background: rgba(243, 199, 162, 0.08);
  border-left: 4px solid #f3c7a2;
}
.unread-dot{
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 12px;
  border-radius: 50%;
  background: #ff4d4f;
  vertical-align: middle;
}
.container .content .listItem .listTitle{
  font-size: 38px;
}
.container .content .listItem .listContent{
  border-bottom: 2px solid #f2f2f5;
  padding: 5px 0;
  font-size: 25px;
}
.container .content .listItem .listTime{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 70px;
}
.container .content .listItem .listTime .listTimeText {
  color: #f3c7a2;
  font-size: 30px;
}
</style>
